import { Alert } from 'antd';

import styles from './Alert.module.less';

const HVAlert = props => {
    return (
        <Alert
            {...props}
            className={[props['className'] ?? '', styles['alert']].join(' ')}
            data-test-id={`feedback-alert-${props.type}`}
        />
    );
};

export default HVAlert;
